import type { FC } from "react";
import { useParams } from "react-router";
import { useProjectWorkspaceId } from "../projectWorkspace.js";
import { WorkspaceId } from "../workspaces.js";
import { RecruitingNavigationMenu } from "./recruitingNavigationMenu.js";
import { TrainingNavigationMenu } from "./trainingNavigationMenu.js";

// A project belongs to either the Recruiting or Training workspace depending on
// its type, so it renders the matching section menu (each carries its own
// search context).
export const ProjectNavigationMenu: FC = () => {
  const { projectId } = useParams();
  const workspaceId = useProjectWorkspaceId(projectId);

  return workspaceId === WorkspaceId.Training ? (
    <TrainingNavigationMenu />
  ) : (
    <RecruitingNavigationMenu />
  );
};
